import request from "../request"

const base = "/workbenchApi/pm-self-check"
export const getProjectHQNewStagesApi = (projectId: string | number) =>
  request.get<unknown, API.PROJECTHQ_NEW.Stage[]>(`${base}/projects/${projectId}/stages`)
export const getProjectHQNewTasksApi = (itemId: number, projectId: string | number) =>
  request.get<unknown, API.PROJECTHQ_NEW.Task[]>(`${base}/items/${itemId}/tasks`, { params: { projectId } })
export const updateProjectHQNewTaskStatusApi = (taskId: number, status: 0 | 1) =>
  request.patch<unknown, API.PROJECTHQ_NEW.Task>(`${base}/tasks/${taskId}/status`, { status })
export const updateProjectHQNewTaskCompletedAtApi = (taskId: number, completedAt: string | null) =>
  request.patch<unknown, API.PROJECTHQ_NEW.Task>(`${base}/tasks/${taskId}/completed-at`, { completedAt })
export const getProjectHQNewTaskAttachmentsApi = (taskId: number) =>
  request.get<unknown, API.PROJECTHQ_NEW.Attachment[]>(`${base}/tasks/${taskId}/files`)
export const uploadProjectHQNewTaskAttachmentApi = (taskId: number, file: File) => {
  const body = new FormData()
  body.append("file", file)
  return request.post<unknown, API.PROJECTHQ_NEW.Attachment>(`${base}/tasks/${taskId}/upload`, body)
}
export const deleteProjectHQNewTaskAttachmentApi = (fileId: number) =>
  request.delete<unknown, unknown>(`${base}/tasks/files/${fileId}`)
